<template>
    <div>
      <div style="margin: 10px 0">
        <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="30%">
          <span>请选择公司以及池塘查看数据</span>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
          </span>
        </el-dialog>
        <el-input style="width: 200px;" type="text" v-model="pondid" placeholder="请输入池塘号" suffix-icon="el-icon-search"></el-input>
        <!-- <div style="width: 380px; display: inline-block;" class="block">
            <el-date-picker
                style="width: 380px;"
                v-model="value1"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                >
            </el-date-picker>
        </div> -->
        <el-button style="margin-left: 10px;" type="primary" @click="load" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" @click="load" icon="el-icon-refresh">重置</el-button>
        <!-- <el-button style="float:right; " type="primary" @click="exp">导出<i class="el-icon-top"></i></el-button> -->
        <!-- <el-upload
          action="http://localhost:9090/user/import" :on-success = 'handelsuccess' style="float:right;margin-left: 10px">
          <el-button style="float:right;" type="primary">导入<i class="el-icon-bottom"></i></el-button>
        </el-upload> -->
        <!-- <el-button style="float:right; margin-left: 10px" type="danger" @click = "deleteBatch">批量删除<i class="el-icon-remove-outline"></i></el-button> -->
        <el-button type="success" icon="el-icon-circle-plus-outline" @click="handAdd()">新增</el-button>
        <el-select v-model="pondid" clearable placeholder="请选择要查看的池塘"style="float:right">
          <el-option v-for="item in options2" 
          :key="item.id"
          :label="item.name"
          :value="item.id"></el-option> 
        </el-select>
        <el-select v-model="comid" clearable placeholder="请选择要查看的公司" v-if = "role === '超级管理员'" style="float:right">
          <el-option v-for="item in options1" 
          :key="item.id"
          :label="item.name"
          :value="item.id"></el-option>
        </el-select>
        
        <!-- <el-button style="float:right;" type="primary" @click = "handAdd" icon="el-icon-circle-plus-outline">新增</el-button> -->
      </div>
      <!-- eslint-disable-next-line -->
      <el-table :data="tableData" border stripe :header-cell-class-name="headerBg" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <!-- <el-table-column prop="id" label="ID" width="100">
        </el-table-column>
        <el-table-column prop="pondsid" label="池塘id" width="140">
        </el-table-column> -->
        <el-table-column prop="fishVar" label="鱼类">
        </el-table-column>
        <!-- <el-table-column prop="age" label="日龄(天)">
        </el-table-column> -->
        <el-table-column prop="length" label="平均体长(cm)">
        </el-table-column>
        <el-table-column prop="weight" label="平均体重(g)">
        </el-table-column>
        <el-table-column prop="time" label="时间">
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope"><!-- scope 拿到数据-->
            <!-- <el-button type="success" @click = "handEdit(scope.row)" style="margin-right: 5px">编辑<i class="el-icon-edit"></i></el-button> -->
            <el-button type="success" @click="handEdit(scope.row)">编辑</el-button>
            <el-popover
              placement="top"
              width="160"
              trigger="click">
              <p>您确定删除吗</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                <el-button type="primary" size="mini" @click=handdele(scope.row.id)>确定</el-button>
              </div>
              <el-button type="danger"  slot="reference">删除<i class="el-icon-remove-outline"></i></el-button>
            </el-popover>
            
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 10px 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <el-dialog title="鱼体数据" :visible.sync="dialogFormVisible" width="30%" >
        <el-form ref="form" :model="form" label-width="100px">
          <el-form-item label="投喂鱼类">
            <el-input v-model="form.fishVar"></el-input>
          </el-form-item>
          <el-form-item label="平均体长(cm)">
            <el-input v-model="form.length"></el-input>
          </el-form-item>
          <el-form-item label="平均体重(g)">
            <el-input v-model="form.weight"></el-input>
          </el-form-item>
          <!-- <el-form-item label="日龄">
            <el-input v-model="form.age"></el-input>
          </el-form-item> -->
          <el-form-item label="测量时间">
            <el-date-picker
            v-model="form.time"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
          </el-form-item>
          <el-form-item label="所属公司">
            <el-select v-model="comid" clearable placeholder="请选择要查看的公司" v-if = "role === '超级管理员'" >
                <el-option v-for="item in options1" 
                :key="item.id"
                :label="item.name"
                :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="所属池塘">
            <el-select v-model="form.pondsid" clearable placeholder="请选择要查看的池塘">
                <el-option v-for="item in options2" 
                :key="item.id"
                :label="item.name"
                :value="item.id"></el-option> 
              </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="test">确定</el-button>
            <el-button @click ='shutDown'>取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    </template>
    
    <script>
    export default {
      name: "User",
      data () {
        return{
          tableData: [],
          pageNum: 1,
          pageSize: 10,
          total: 0,
          dialogFormVisible: false,
          form: {},
          multipleSelection: {},
          headerBg: 'headerBg',
          data: {},
          value1: '',
          options1:[],
          options2:[],
          user: localStorage.getItem("user")?JSON.parse(localStorage.getItem("user")):{},
          pondid: null,
          comid:null,
          role: (localStorage.getItem("user")?JSON.parse(localStorage.getItem("user")):{}).role,
          dialogVisible: true,
        }
      },
      mounted () {
        //请求分页查询
        // this.load()
        if(this.role == "超级管理员"){
          this.getcompanies()
        }else{
          this.getPonds(this.user.companyid)
        }
        
      },
      methods: {
        load () {//点击页码进行get请求
          this.request.get('/api/fishData/page', {
            params: {
              pageNum: this.pageNum,
              pageSize: this.pageSize,
              pondid: this.pondid,
              companyId: this.user.companyid,
            }
          }).then(res => {
            this.tableData = res.records
            this.total = res.total
          }).catch(error => {
            console.error(error)
          })
        },
        getcompanies () {
          this.request.get('/api/companies/').then(res => {
            if(res.code === "200"){
              this.options1 = res.data.map(item => {
                return {
                  id: item.id,
                  name: item.name
                }
              })
            }else{
              console.log(res.code, res.data);
            }
          })
        },
        getPonds (comid){
            if (isNaN(comid)) {  
            // 如果 comid 不是数字，则设置一个默认值或者处理错误  
            comid = 0; // 或者你可以抛出一个错误，或者根据需要处理这种情况  
            }  
            this.request.get('/api/ponds/getponds', {
                params:{
                    comid: comid
                }
            }).then(res=> {
                if(res.code === "200") {
                    this.options2 = res.data.map(item => {
                        return {
                            id: item.id,
                            name: item.name
                        }
                    })
                }else{
                    console.log(res.msg);
                }
                
            }).catch(error =>{
                console.log(error);
            })
        },
        save () { // 新增或更新
          this.request.post('/api/fishData/', this.form).then(res => {
            if (res) {
              this.$message.success('保存成功')
              this.dialogFormVisible = false
              this.load()
            } else {
              this.$message.success('保存失败')
            }
          })
        },
        seleteLoad(){
          this.request.get('/api/fishData/page', {
            params: {
              pageNum: this.pageNum,
              pageSize: this.pageSize,
              pondid: this.pondid,
            }
          }).then(res => {
            this.tableData = res.records
            this.total = res.total
          }).catch(error => {
            console.error(error)
          })
        },
        handAdd () {
          this.dialogFormVisible = true //打开表单
          this.form = {}
        },
        handEdit (row) { //把row里的数据传给表单
          this.form = row
          this.dialogFormVisible = true
        },
        handdele (id) { //通过id删除
          this.request.delete('/api/fishData/' + id).then(res => {
            if (res) {
              this.$message.success('删除成功')
              this.load()
            } else {
              this.$message.success('删除失败')
            }
          })
        },
        handleSelectionChange (val) {
          console.log(val)
          this.multipleSelection = val
        },
        deleteBatch () {
          // eslint-disable-next-line
          let ids = this.multipleSelection.map(val => val.id)
          this.request.delete('/user/del/batch' + ids).then(res => {
            if (res) {
              this.$message.success('批量删除成功')
              this.load()
            } else {
              this.$message.success('删除失败')
            }
          })
        },
        shutDown () {
          this.dialogFormVisible = false
        },
        exp () { //导出
          window.open("http://localhost9090/user/export")
        },
        handelsuccess () {
          this.$message.success('文件上传成功')
          this.load()
        },
        handleSizeChange (pageSize) {
          this.pageSize = pageSize
          this.load()
        },
        handleCurrentChange (pageNum) {
          this.pageNum = pageNum
          this.load()
        },
        test(){
            console.log(this.form.time);
            console.log(this.form.pondsid);
        }
      },
      watch: {
        comid (comid) {
          this.getPonds(comid)
        },
        pondid (pondid) {
          this.seleteLoad()
        }
        
      }
    }
    </script>
    
    <style scoped>
    
    </style>
    